import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import DisclaimerBar from "./DisclaimerBar";
import ChatWidget from "./ChatWidget";
import CookieConsent from "./CookieConsent";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-paper">
      <DisclaimerBar />
      <Header />
      <main className="mx-auto w-full max-w-desk flex-1 border-x border-hair px-5 sm:px-8">
        <Outlet />
      </main>
      <Footer />
      <ChatWidget />
      <CookieConsent />
    </div>
  );
}
